import React, { useState, useEffect } from "react";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_Null_School_Or_Country_Attendees } from "../api/Get_Null_School_Or_Country_Attendees";
import SearchSchoolsSetSchool from "../../../components/Search/SearchSchoolsSetSchool";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Button } from "@mui/material";

function AssignSXPAttendeeToSchool() {
  const { logout } = StaffuseAuth();

  // Assuming Attendee state is fetched from an API using the id
  const [Attendee, setAttendee] = useState({
    _id: "",
    BasicInfo: {
      Created_At: "",
      First_Name: "",
      Last_Name: "",
      Gender: "",
      Nationality: "",
      Country: "",
      DOB: "",
      uncleanSchool: "",
      School_id: "",
      ProgrammeTitle: "",
      ProgrammeDate: "",
      ProgrammeVarient: "",
      ProgrammeAge: "",
    },
    OrderInfo: {
      OriginalOrderPlatform: "Manual Entry",
      OriginalOrderNumber: "",
      LineItemPrice: "",
      LineItemDiscount: "",
      Deposit: "",
      Airport_Price: "",
      Accom_Meals: "",
      DiscountCode: "",
      GrossOrNet: "",
    },
    Contacts: [],
    Notes: [],
    MetaData: {
      Reserved: "",
      Archived: "",
      CreatedBy: localStorage.getItem("Username"),
      PrimaryStaff: "",
      Bursary: "",
      TCS: "",
      Password: "",
    },
    IPInfo: {},
    VISA: {},
    SEFProgress: {},
  });

  const [skip, setSkip] = useState(
    //1
    //random number between 1 and 400
    Math.floor(Math.random() * 70) + 1
  );
  const handleSkip = (e) => {
    setSkip(skip + 1);
    handleGetNew(e);
  };

  useEffect(() => {
    Get_Null_School_Or_Country_Attendees(
      "Registers_2025",
      "All",
      setAttendee,
      1,
      "GetOne",
      "SXP",
      0,
      logout
    );
  }, []);

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleChoose = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: { ...Attendee.BasicInfo, [e.target.name]: e.target.value },
    });
  };

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBasicUpdate = (e) => {
    e.preventDefault();
    let id = Attendee._id;
    let data = Attendee;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      id,
      logout
    );
  };

  const handleGetNew = (e) => {
    e.preventDefault();
    Get_Null_School_Or_Country_Attendees(
      "Registers_2025",
      "All",
      setAttendee,
      1,
      "GetOne",
      "SXP",
      skip,
      logout
    );
  };

  const handleTBC = (e) => {
    e.preventDefault();
    let id = Attendee._id;
    let data = Attendee;
    delete data._id;
    data.BasicInfo.uncleanSchool = "TBC";
    Update_To_MongoDB_By_ID(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      id,
      logout
    );

    Update_To_MongoDB_By_ID(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      id,
      logout
    );
  };

  console.log(Attendee);
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "45%" }}>
          <h1>Assign SXP to School or Country {skip}</h1>
          <p>
            If any SXP bookings are not assigend to a school, you can help out
            here !<br></br>
            <br></br>
            Use the basic information on the right, then search our database,
            choose the school, click "Update" and then click "Get Next Attendee"
            to go to the next example.<br></br>
            <br></br>If the school does not exist, open the "Add School" page in
            another tab and add the school. Then try searching again.
          </p>
          <SearchSchoolsSetSchool
            handleChoose={handleChoose}
            Attendee={Attendee}
          />
        </div>
        <div style={{ width: "45%" }}>
          <h1>Info:</h1>
          <h2> First Name: {Attendee.BasicInfo?.First_Name || ""}</h2>
          <h2> Last Name: {Attendee.BasicInfo?.Last_Name || ""}</h2>
          <h2> Country: {Attendee.BasicInfo?.Country || ""}</h2>
          <h2> Nationality: {Attendee.BasicInfo?.Nationality || ""}</h2>
          <h2> uncleanSchool: {Attendee.BasicInfo?.uncleanSchool || ""}</h2>
          <h2>
            uncleanSchoolCountry:{" "}
            {Attendee.BasicInfo?.uncleanSchoolCountry || ""}
          </h2>
          <h2>
            uncleanSchoolCity: {Attendee.BasicInfo?.uncleanSchoolCity || ""}
          </h2>
          <br></br>
          <h2> Attendee _id: {Attendee._id}</h2>
          <h2> School _id: {Attendee.BasicInfo?.School_id}</h2>
          <h1>Actions:</h1>
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            disabled={
              isSubmitting ||
              !Attendee.BasicInfo?.School_id ||
              !Attendee.BasicInfo?.School_id.length > 0
            }
            style={{ backgroundColor: "green" }}
            onClick={(e) => handleBasicUpdate(e)}
          >
            {isSubmitting ? "Submitting..." : "Update Attendee"}
          </Button>
          {/* <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            onClick={(e) => handleGetNew(e)}
          >
            {isSubmitting ? "Submitting..." : "Get Next Attendee"}
          </Button> */}
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            onClick={(e) => handleSkip(e)}
          >
            Skip
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            onClick={(e) => handleTBC(e)}
            style={{ backgroundColor: "purple" }}
          >
            Mark as TBC (Cannot be known at this time/ waiting for WEF or SEF)
          </Button>
        </div>{" "}
      </div>
    </div>
  );
}

export default AssignSXPAttendeeToSchool;
